import styled from "styled-components";

export const PropertiesNamesWrapper = styled.div`
  display: flex;
`;

export const Name = styled.p`
  margin: 5px 5px 0 0;
`;
